

// screens/settings/AccountSetting.js (updated)
import { getPositionWithFallback, useLocationPermissionSync } from "../../../utils/getPositionWithFallback";
import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { Box, IconButton, Checkbox, useTheme, FormControl, Select, MenuItem } from '@mui/material';
import CustomText, { textStyles } from '../../../components/CustomText';
import spanish from '../../../assets/spanish.svg';
import MultiSelectDropdown from '../../../components/MultiSelectionDropdown';
import CustomDropdownInput from '../../../components/CustomDropdown';
import CustomButton from '../../../components/CustomButton';
import save from '../../../assets/save.svg';
import { useFormik } from 'formik';
import { toast, Toaster } from 'react-hot-toast';
import '../../../App.css';
import back from "../../../assets/back.svg";
import profileperson from "../../../assets/profileperson.png";
import CustomPasswordInput from '../../../components/PasswordInput';
import usa from "../../../assets/usa.png";
import germany from "../../../assets/germany.png";
import france from "../../../assets/france.webp";
import italy from "../../../assets/italy.png";
import down from '../../../assets/down.svg';
import arrow from '../../../assets/arrow.svg';
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../Redux/Slices/AuthSlice";
import DeleteSettingsModal from "./Delete";
import countryList from "react-select-country-list";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import { decryptToken } from "../../../Utlis/Encryption";
import { BASE_URL } from '../../../components/BaseUrl';
import dummy from "../../../assets/dummy.png"
import CircularProgress from "@mui/material/CircularProgress"; // <-- added
import { useOutletContext, useNavigate } from 'react-router-dom';
import { useTheme as useThemeContext } from '../../../contexts/ThemeContext';
import { GoogleMap, Marker, Circle } from "@react-google-maps/api";
import SearchIcon from "@mui/icons-material/Search";
import RoomIcon from "@mui/icons-material/Room";
import AddIcon from "@mui/icons-material/Add";
import crossmap from "../../../assets/crossmap.svg";
import LocationPermissionModal from "../../../components/PermissionModal";
import ImageCropper from "../../../components/ImageCropper";
import CloseIcon from "@mui/icons-material/Close";
import document1 from "../../../assets/document1.svg";
import imageicon from "../../../assets/imageicon.png";
import { InputBase } from "@mui/material"; // Import InputBase for search
import SearchableDropdown from '../../../components/SearchableDropdown';
import websitelogo from "../../../assets/websitelogo.png";
import projectlogo from "../../../assets/projectlogo.png";
import SettingCard from '../../../components/Cards/SettingCard';
import card1 from "../../../assets/Settings/card1.svg";
import card2 from "../../../assets/Settings/card2.svg";
import card3 from "../../../assets/Settings/card3.svg";
import ChangePassword from "../../AdminPages/Dashboard/ChangePassword"
import usePlanAccess from "../../../hooks/usePlanAccess";

import {
  getCountriesByRegions,
  getCitiesByCountryNames,
} from "../../AuthPages/Registeration/Helper";
import {
  normalizeLatLng,
  iso2ToContinent,
  pickReverseGeocodeResult,
  parseGoogleAddressComponents,
} from "../../../utils/googleGeocodeUtils";





const defaultCenter = { lat: 33.6844, lng: 73.0479 }; // Islamabad, Pakistan

const circularRadius = 100;


const mapContainerStyle = {
  width: "100%",
  height: "100%",
};
const AccountSetting = ({ onBack }) => {
  const [openChangePassword, setOpenChangePassword] = useState(false);
const [hasCheckedPermission, setHasCheckedPermission] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t ,i18n } = useTranslation("");
  const { canAccess } = usePlanAccess();
  const [savingProfile, setSavingProfile] = useState(false);
  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);
  const [deleteAccountLoading, setDeleteAccountLoading] = useState(false);

  const handleDeleteAccount = async (password, deletionReason) => {
    setDeleteAccountLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/company-admins/me/delete`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${decryptedToken}`,
        },
        body: JSON.stringify({
          password,
          deletion_reason: deletionReason,
        }),
      });

      const data = await res.json();

      if (res.ok && !data.error) {
        toast.success(data.message || "Account deleted successfully");
        setDeleteAccountOpen(false);
        await dispatch(logout());
        navigate("/");
      } else {
        toast.error(data.message || "Failed to delete account");
      }
    } catch (err) {
      toast.error(err.message || "Network error while deleting account");
    } finally {
      setDeleteAccountLoading(false);
    }
  };
  const { updateProfile } = useOutletContext();  // Access the updateProfile function from context
  const { fetchThemeColors, updateColors } = useThemeContext(); // Access theme context
const isOnline = () => navigator.onLine;

const [searchCountry, setSearchCountry] = useState(""); // State for country search
const [searchProvince, setSearchProvince] = useState(""); // State for province search
const [searchCity, setSearchCity] = useState(""); 
const getDocumentMeta = (url) => {
  if (!url) return { type: null, icon: null, fileName: "" };
  const isPdf = url.toLowerCase().endsWith(".pdf");
  const icon = isPdf ? document1 : imageicon;
  const fileName = url.split("/").pop();

  return { type: isPdf ? "pdf" : "image", icon, fileName };
};

const [mapRef, setMapRef] = useState(null);
const [suggestions, setSuggestions] = useState([]);
  const [initialLocation, setInitialLocation] = useState(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!decryptedToken) return;
      try {
        setInitLoading(true);
        const res = await fetch(`${BASE_URL}/company-admins/profile`, {
          headers: { Authorization: `Bearer ${decryptedToken}` },
        });
        const json = await res.json();
        if (!res.ok || json.error) throw new Error(json.message || "Failed to load profile");

        // 🔥 Merge API objects
        const profile = {
          ...json.data.user,
          ...json.data.company,
          ...json.data.location,
          ...json.data.coordinates,
          ...json.data.territory,
          ...json.data.status,
        };

        // Handle profile image
        if (profile.profile_picture) {
          setProfileImageRaw(profile.profile_picture);
          setPreviewUrl(profile.profile_picture);
        }

        // Handle company logo
        if (profile.logo) {
          setCompanyLogoUrl(profile.logo);
        }

        // Read territory/account executive from raw response as they may not be inside merged blocks
        const respTerritory = json?.data?.territory_zone || json?.data?.zone || null;
        const respAccountExecutive = json?.data?.account_executive || null;

        // ✅ Fill Formik with profile data
        console.log("[DEBUG] Loading profile data:", {
          backendCity: profile.city,
          backendCountry: profile.country,
          backendProvince: profile.province
        });
        
        formik.setValues({
          firstName: profile.first_name || "",
          lastName: profile.last_name || "",
          middleName: profile.middle_name || "",
          dob: profile.dob ? profile.dob.split('T')[0] : "",
          adminType: profile.administrator_type || "",
          adminDocumentUrl: profile.admin_document_url || "",
          phone: profile.phone_number || "",
          profile_picture: profile.profile_picture || "",

          legal_name: profile.legal_name || "",
          trade_name: profile.trade_name || "",
          business_sector: profile.business_sector || "",
          company_registration_number: profile.company_registration_number || "",
          business_email: profile.business_email || "",
          business_phone_number: profile.business_phone || "",
          // business_type: profile.business_type || "",
          business_activity: profile.business_activity || "",
          business_color: profile.business_color || "#1976d2",
          primary_color: profile.primary_color || "#1976d2",
          secondary_color: profile.secondary_color || "#6B778C",
          company_document_url: profile.company_document_url || "",
          business_address: profile.business_address || "",
          logo: profile.logo || "",

          country: profile.country || "",
          community: profile.community || "",
          province: profile.province || "",
          city: profile.city || "",
          postal_code: profile.postal_code || "",
          street_address: profile.street_address || "",
          region_code: profile.region_code || "",

          regions: respTerritory?.territory_zone || [],
          countriesSel: respTerritory?.territory_countries || [],
          citiesSel: respTerritory?.territory_cities || [],
          target_market: respTerritory?.target_market || "",
          account_executive_id: respAccountExecutive?.id || "",
        });

        // ✅ Push lat/lng into map initialLocation
        setInitialLocation({
          lat: profile.latitude || null,
          lng: profile.longitude || null,
        });

        const addrFromProfile =
          (profile.business_address || "").trim() ||
          [profile.street_address, profile.city, profile.province, profile.postal_code, profile.country]
            .filter(Boolean)
            .join(", ");
        if (addrFromProfile) {
          setAddress(addrFromProfile);
          setDisplayAddress(addrFromProfile);
        }
      } catch (err) {
        toast.error(err.message);
      } finally {
        setInitLoading(false);
      }
    };

    fetchProfile();
  }, [decryptedToken]);

  const safeLog = () => { };
  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      middleName: '',
      dob: '',
      adminType: '',
      adminDocumentUrl: '',
      phone: '',
      profile_picture: '',


      legal_name: '',
      trade_name: '',
      business_sector: '',
      company_registration_number: '',
      business_email: '',
      business_phone_number: '',
      // business_type: '',
      business_activity: '',
      business_color: '#1976d2',
      primary_color: '#1976d2',
      secondary_color: '#6B778C',
      company_document_url: '',
      business_address: '',
      logo: '',

      // Company location
      country: 'Spain',
      community: '',
      province: '',
      city: '',
      postal_code: '',
      street_address: '',
      region_code: '',

      regions: [],
      countriesSel: [],
      citiesSel: [],

      territory_zone: [],
      territory_countries: [],
      territory_cities: [],
      target_market: '',
      account_executive_id: '',
    },
    validate: (values) => {
      const errors = {};

      // First Name (Full Name)
      if (!values.firstName || (typeof values.firstName === "string" && values.firstName.trim() === "")) {
        errors.firstName = t("account_setting_screen.validation.firstNameRequired") || "First name is required";
      }

      // Last Name
      if (!values.lastName || (typeof values.lastName === "string" && values.lastName.trim() === "")) {
        errors.lastName = t("account_setting_screen.validation.lastNameRequired") || "Last name is required";
      }

      // Date of Birth
      if (!values.dob || (typeof values.dob === "string" && values.dob.trim() === "")) {
        errors.dob = t("account_setting_screen.validation.dobRequired") || "Date of birth is required";
      }

      // Phone Number
      if (!values.phone || (typeof values.phone === "string" && values.phone.trim() === "")) {
        errors.phone = t("account_setting_screen.validation.phoneRequired") || "Phone number is required";
      }

      // Legal Business Name (required for both individual and legal_entity)
      if (!values.legal_name || (typeof values.legal_name === "string" && values.legal_name.trim() === "")) {
        errors.legal_name = t("account_setting_screen.validation.legalNameRequired") || "Legal business name is required";
      }

      // Business Sector
      if (!values.business_sector || (typeof values.business_sector === "string" && values.business_sector.trim() === "")) {
        errors.business_sector = t("account_setting_screen.validation.businessSectorRequired") || "Business sector is required";
      }

      // // Business Type
      // if (!values.business_type || (typeof values.business_type === "string" && values.business_type.trim() === "")) {
      //   errors.business_type = t("account_setting_screen.validation.businessTypeRequired") || "Business type is required";
      // }

      // Business Phone Number
      if (!values.business_phone_number || (typeof values.business_phone_number === "string" && values.business_phone_number.trim() === "")) {
        errors.business_phone_number = t("account_setting_screen.validation.businessPhoneRequired") || "Business phone number is required";
      }

      // Business Activity
      if (!values.business_activity || (typeof values.business_activity === "string" && values.business_activity.trim() === "")) {
        errors.business_activity = t("account_setting_screen.validation.businessActivityRequired") || "Business activity is required";
      }

      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    onSubmit: async (values) => {
      try {
        // Guard: warn if preview exists but raw server path missing
        if (previewUrl && !profileImageRaw) {
          console.warn("⚠️ You have a preview blob but no uploaded server URL yet. The profile image may be null on backend.");
        }
        setSavingProfile(true); // <-- start loader



        const payload = {
          // --- Personal Details ---
          first_name: values.firstName,
          last_name: values.lastName,
          middle_name: values.middleName,
          dob: values.dob,
          administrator_type: values.adminType,
          admin_document_url: values.adminDocumentUrl,
          phone_number: values.phone,
          profile_picture: profileImageRaw || "",
          // --- Company Details ---
          legal_name: values.legal_name,
          trade_name: values.trade_name,
          business_sector: values.business_sector,
          company_registration_number: values.company_registration_number,
          business_email: values.business_email,
          business_phone_number: values.business_phone_number,
          // business_type: values.business_type,
          business_activity: values.business_activity,
          business_color: values.business_color,
          primary_color: values.primary_color,
          secondary_color: values.secondary_color,
          company_document_url: values.company_document_url,
          business_address: values.business_address,
          logo: values.logo || "",

          // --- Location ---
          country: values.country,
          community: values.community,
          province: values.province,
          city: values.city,
          postal_code: values.postal_code,
          street_address: values.street_address,
          region_code: values.region_code,

          // --- Map derived (only if manual address is OFF) ---
          ...(!manualAddress ? {
            latitude: values.latitude ?? null,
            longitude: values.longitude ?? null,
            timezone: values.timezone || '',
            countryCode: values.countryCode || '',
            region: values.region || '',
            continent: values.continent || ''
          } : {}),

          // --- Target Market ---
          territory_zone: values.regions || [],
          territory_countries: values.countriesSel || [],
          territory_cities: values.citiesSel || [],
          target_market: values.target_market,
          account_executive_id: values.account_executive_id,
        };

        console.log("[PROFILE UPDATE] Sending payload:", payload); // ✅ confirms what's going in body
        console.log("[DEBUG] City values:", {
          formikCity: formik.values.city,
          selectedCity: selectedCity,
          cityInPayload: payload.city
        });

        const res = await fetch(`${BASE_URL}/company-admins/setup-complete-profile`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${decryptedToken}`,
          },
          body: JSON.stringify(payload),
        });

        const data = await res.json();
        if (!res.ok || data.error) {
          throw new Error(data.message || "Failed to update profile");
        }

        toast.success(data.message || "Profile updated successfully");
        updateProfile(data.data);  // Pass the updated profile to parent component
        
        // Update theme colors and logo globally after successful save
        updateColors(
          formik.values.primary_color || '#006EC2',
          formik.values.secondary_color || '#002DC2',
          companyLogoUrl || ''
        );
        
        // Also fetch fresh theme data from API
        fetchThemeColors();


      } catch (err) {
        toast.error(err.message || "Something went wrong");
      }
      finally {
        // Safety: make sure loader stops even on errors
        setSavingProfile(false);
      }
    }
  });

  // ---- Target Region/Zone/Cities: same approach as Region.js ----

  // Static list of allowed regions (continents) exactly like Region.js
  const [regionOptions, setRegionOptions] = useState([]);
  const [initLoading, setInitLoading] = useState(true);

  useEffect(() => {
    const ALL_REGIONS = [
      "North America",
      "South America",
      "Europe",
      "Asia",
      "Africa",
      "Oceania",
    ];
    setRegionOptions(ALL_REGIONS);
    setInitLoading(false);
  }, []);

  // Accept array or event.target.value (robust with different multi-selects)
  const toArray = (input) => {
    if (Array.isArray(input)) return input;
    if (input && input.target) return input.target.value ?? [];
    return [];
  };

  // Compute countries from selected regions


  // Compute cities from selected countries
  const cityOptions = useMemo(() => {
    if (!formik.values.countriesSel.length) return [];
    return getCitiesByCountryNames(formik.values.countriesSel);
  }, [formik.values.countriesSel]);

  // Clear children on parent change (exact same cascade behavior)
  const handleRegionsChange = (input) => {
    const vals = toArray(input);
    formik.setFieldValue("regions", vals);
    formik.setFieldValue("countriesSel", []);
    formik.setFieldValue("citiesSel", []);
  };

  const handleCountriesChange = (input) => {
    const vals = toArray(input);
    formik.setFieldValue("countriesSel", vals);
    formik.setFieldValue("citiesSel", []);
  };

  const handleCitiesChange = (input) => {
    const vals = toArray(input);
    formik.setFieldValue("citiesSel", vals);
  };
  const [manualAddress, setManualAddress] = useState(false);
  const countryOptions = useMemo(() => {
    return countryList()
      .getData()
      .map((country) => ({
        value: country.label,
        label: (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <img
              src={`https://flagcdn.com/w40/${country.value.toLowerCase().slice(0, 2)}.png`}
              alt={country.label}
              style={{ width: 20, height: 15, objectFit: "contain" }}
            />
            {country.label}
          </div>
        ),
        code: country.value,
      }));
  }, []);


  // ------- UPLOAD HANDLER -------
  // ⬇️ REPLACE handleImageSelect with this:





  const targetCountryOptions = useMemo(() => {
    if (!formik.values.regions.length) return [];
    return getCountriesByRegions(formik.values.regions).map((c) => c.name); // array of strings
  }, [formik.values.regions]);



  const handleMapLocation = useCallback((loc) => {
    if (manualAddress) return;

    formik.setFieldValue("postal_code", loc.postalCode || "");
    formik.setFieldValue("city", loc.city || "");
    formik.setFieldValue("province", loc.province || "");
    formik.setFieldValue("community", loc.community || "");
    formik.setFieldValue("street_address", loc.streetAddress || "");


    formik.setFieldValue("country", loc.country || "");
    formik.setFieldValue("latitude", loc.latitude ?? null);
    formik.setFieldValue("longitude", loc.longitude ?? null);
    formik.setFieldValue("countryCode", loc.countryCode || "");
    formik.setFieldValue("region", loc.region || "");
    formik.setFieldValue("continent", loc.continent || "");
  }, [manualAddress, formik]);


  const fileInputRef = useRef(null);
  const docInputRef = useRef(null);
  const companyDocInputRef = useRef(null);
  const companyLogoInputRef = useRef(null);

  const [profileImageRaw, setProfileImageRaw] = useState(""); // value you send to backend
  const [previewUrl, setPreviewUrl] = useState("");           // local blob for instant preview
  const [uploadingAdminDoc, setUploadingAdminDoc] = useState(false);
  const [adminDocFileName, setAdminDocFileName] = useState("");
  const [uploadingCompanyDoc, setUploadingCompanyDoc] = useState(false);
  const [companyDocFileName, setCompanyDocFileName] = useState("");
  
  // Image cropper states
  const [cropModalOpen, setCropModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  
  // Company logo states
  const [companyLogoUrl, setCompanyLogoUrl] = useState("");
  const [uploadingCompanyLogo, setUploadingCompanyLogo] = useState(false);
  const [companyLogoCropModalOpen, setCompanyLogoCropModalOpen] = useState(false);
  const [selectedCompanyLogoImage, setSelectedCompanyLogoImage] = useState(null);

  // Location-related state
  const [searchBarOpen, setSearchBarOpen] = useState(false);
  const [position, setPosition] = useState(defaultCenter);
  const [address, setAddress] = useState("Fetching address...");
  const [displayAddress, setDisplayAddress] = useState("Fetching address...");
  const [showFullMap, setShowFullMap] = useState(false);
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  // Country/State/City cascading dropdowns data
  const [countriesData, setCountriesData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [loadingCountries, setLoadingCountries] = useState(false);
  const [loadingStates, setLoadingStates] = useState(false);
  const [loadingCities, setLoadingCities] = useState(false);

  // Account Executive states
  const [executives, setExecutives] = useState([]);
  const [executivesLoading, setExecutivesLoading] = useState(false);
  const [accountExecutiveInfo, setAccountExecutiveInfo] = useState(null); // Store account executive info from profile

  const buildDisplayUrl = (raw) => {
    if (!raw) return "";
    if (raw.startsWith("data:")) return raw;
    if (/^https?:\/\//i.test(raw)) return raw;
    const prefix = raw.startsWith("/") ? "" : "/";
    return `${BASE_URL}${prefix}${raw}`;
  };

  const extractUploadUrl = (data) =>
    data?.url ||
    data?.imageUrl ||
    data?.path ||
    data?.filePath ||
    data?.location ||
    data?.result?.url ||
    data?.result?.path ||
    data?.data?.url ||
    data?.data?.path ||
    data?.data?.location ||
    "";
  // const handleImageSelect = async (e) => {
  //   const file = e?.target?.files?.[0];
  //   if (!file) return;

  //   console.log("🖼️ [UPLOAD] Selected file:", {
  //     name: file.name,
  //     size: file.size,
  //     type: file.type,
  //   });

  //   // Create image URL for cropping
  //   const imageUrl = URL.createObjectURL(file);
  //   setSelectedImage(imageUrl);
  //   // setCropModalOpen(true);
    
  //   if (fileInputRef.current) fileInputRef.current.value = "";
  // };
const handleImageSelect = async (e) => {
  const file = e?.target?.files?.[0];
  if (!file) return;

  console.log("🖼️ [UPLOAD] Selected file:", {
    name: file.name,
    size: file.size,
    type: file.type,
  });

  // Create image URL for preview (optional)
  const imageUrl = URL.createObjectURL(file);
  setSelectedImage(imageUrl); // You can still preview the image if needed

  // Upload the image directly without cropping
  try {
    console.log("🚀 [UPLOAD] Processing image:", {
      name: file.name,
      size: file.size,
      type: file.type,
    });

    const formData = new FormData();
    formData.append("image", file);

    console.log("🚀 [UPLOAD] POST -> /upload/image");
    const res = await fetch(`${BASE_URL}/upload/image`, {
      method: "POST",
      body: formData, // No Content-Type header needed
    });

    const json = await res.json();

    console.log("📥 [UPLOAD] Response status:", res.status, res.statusText);

    if (!res.ok || json?.error) throw new Error(json?.message || "Image upload failed");

    const raw = extractUploadUrl(json); // Assuming the server returns the image URL
    console.log("🔗 [UPLOAD] Extracted server image path/url:", raw);

    // Set the uploaded image's URL
    setProfileImageRaw(raw);
    setPreviewUrl(buildDisplayUrl(raw)); // switch to the server URL for display
    // toast.success("Profile image uploaded successfully");

    // Reset file input (optional)
    if (fileInputRef.current) fileInputRef.current.value = "";

  } catch (err) {
    console.error("❌ [UPLOAD] Error:", err);
    toast.error(err.message || "Upload failed");
  }
};

  const handleCropComplete = async (croppedImageFile) => {
    if (!croppedImageFile) {
      toast.error("Please select a crop area");
      return;
    }
    
    try {
      console.log("🖼️ [CROP] Processing cropped file:", {
        name: croppedImageFile.name,
        size: croppedImageFile.size,
        type: croppedImageFile.type,
      });

      const formData = new FormData();
      formData.append("image", croppedImageFile);

      console.log("🚀 [UPLOAD] POST -> /upload/image");
      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData, // no Content-Type header
      });

      const json = await res.json();

      console.log("📥 [UPLOAD] Response status:", res.status, res.statusText);
      safeLog("[UPLOAD] JSON", json);

      if (!res.ok || json?.error) throw new Error(json?.message || "Image upload failed");

      const raw = extractUploadUrl(json);
      console.log("🔗 [UPLOAD] Extracted server image path/url:", raw);

      setProfileImageRaw(raw);
      setPreviewUrl(buildDisplayUrl(raw)); // switch to server URL
      toast.success("Profile image uploaded and cropped");
      setCropModalOpen(false);
      setSelectedImage(null);
    } catch (err) {
      console.error("❌ [UPLOAD] Error:", err);
      toast.error(err.message || "Upload failed");
    }
  };

  // Company logo handlers
  const handleCompanyLogoSelect = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    console.log("🏢 [COMPANY LOGO] Selected file:", {
      name: file.name,
      size: file.size,
      type: file.type,
    });

    // Create image URL for cropping
    const imageUrl = URL.createObjectURL(file);
    setSelectedCompanyLogoImage(imageUrl);
    setCompanyLogoCropModalOpen(true);
    
    if (companyLogoInputRef.current) companyLogoInputRef.current.value = "";
  };

  const handleCompanyLogoCropComplete = async (croppedImageFile) => {
    if (!croppedImageFile) {
      toast.error("Please select a crop area");
      return;
    }
    
    try {
      setUploadingCompanyLogo(true);
      console.log("🏢 [COMPANY LOGO CROP] Processing cropped file:", {
        name: croppedImageFile.name,
        size: croppedImageFile.size,
        type: croppedImageFile.type,
      });

      const formData = new FormData();
      formData.append("image", croppedImageFile);

      console.log("🚀 [COMPANY LOGO UPLOAD] POST -> /upload/image");
      const res = await fetch(`${BASE_URL}/upload/image`, {
        method: "POST",
        body: formData,
      });

      const json = await res.json();

      console.log("📥 [COMPANY LOGO UPLOAD] Response status:", res.status, res.statusText);
      safeLog("[COMPANY LOGO UPLOAD] JSON", json);

      if (!res.ok || json?.error) throw new Error(json?.message || "Company logo upload failed");

      const raw = extractUploadUrl(json);
      console.log("🔗 [COMPANY LOGO UPLOAD] Extracted server image path/url:", raw);

      setCompanyLogoUrl(raw);
      formik.setFieldValue("logo", raw);
      toast.success("Company logo uploaded and cropped");
      setCompanyLogoCropModalOpen(false);
      setSelectedCompanyLogoImage(null);
    } catch (err) {
      console.error("❌ [COMPANY LOGO UPLOAD] Error:", err);
      toast.error(err.message || "Company logo upload failed");
    } finally {
      setUploadingCompanyLogo(false);
    }
  };
  useEffect(() => {
    return () => {
      if (previewUrl?.startsWith("blob:")) URL.revokeObjectURL(previewUrl);
      if (selectedImage?.startsWith("blob:")) URL.revokeObjectURL(selectedImage);
      if (selectedCompanyLogoImage?.startsWith("blob:")) URL.revokeObjectURL(selectedCompanyLogoImage);
    };
  }, [previewUrl, selectedImage, selectedCompanyLogoImage]);

  // Document upload functions
  const handlePickAdminDoc = () => docInputRef.current?.click();
  const handlePickCompanyDoc = () => companyDocInputRef.current?.click();

  const uploadAdminDocToServer = async (file) => {
    const form = new FormData();
    form.append("pdf", file);
    const res = await fetch(`${BASE_URL}/upload/pdf`, {
      method: "POST",
      body: form,
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");
    return data?.data?.url || data?.url || data?.path || "";
  };

 
  const uploadCompanyDocToServer = async (file) => {
  const isPdf = file.type === "application/pdf";
  const form = new FormData();
  form.append(isPdf ? "pdf" : "image", file);

  const res = await fetch(
    isPdf ? `${BASE_URL}/upload/pdf` : `${BASE_URL}/upload/image`,
    { method: "POST", body: form }
  );

  const data = await res.json();
  if (!res.ok) throw new Error(data?.message || "Upload failed");
  return data?.data?.url || data?.url || data?.path || "";
};

const [imageUploading, setImageUploading] = useState(false); 
const handleAdminDocChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  // ✅ Auto-detect file type
  const type = file.type.startsWith("image/")
    ? "image"
    : file.type === "application/pdf"
    ? "pdf"
    : null;

  if (!type) {
    toast.error("Please select a valid image or PDF file");
    if (docInputRef.current) docInputRef.current.value = "";
    return;
  }

  try {
    setUploadingAdminDoc(true);
    setAdminDocFileName(file.name);

    // ✅ Build FormData
    const form = new FormData();
    form.append(type, file);

    // ✅ Choose correct endpoint
    const endpoint = type === "image" ? "/upload/image" : "/upload/pdf";

    const res = await fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      body: form,
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data?.message || "Upload failed");

    const uploadedUrl = data?.data?.url || data?.url || data?.path || "";

    // ✅ Set the URL in Formik
    formik.setFieldValue("adminDocumentUrl", uploadedUrl);
    toast.success(`${type.toUpperCase()} uploaded successfully`);
  } catch (err) {
    toast.error(err.message || "Failed to upload document");
    formik.setFieldValue("adminDocumentUrl", "");
    setAdminDocFileName("");
  } finally {
    setUploadingAdminDoc(false);
    if (docInputRef.current) docInputRef.current.value = "";
  }
};

  const handleCompanyDocChange = async (e) => {
  const file = e.target.files?.[0];
  if (!file) return;

  const allowed = ["application/pdf", "image/jpeg", "image/png", "image/jpg"];
  if (!allowed.includes(file.type)) {
    toast.error("Only Images or PDFs are allowed.");
    if (companyDocInputRef.current) companyDocInputRef.current.value = "";
    return;
  }

  try {
    setUploadingCompanyDoc(true);
    setCompanyDocFileName(file.name);
    const url = await uploadCompanyDocToServer(file);
    formik.setFieldValue("company_document_url", url);
    toast.success("Document uploaded successfully");
  } catch (err) {
    toast.error("Failed to upload document");
    formik.setFieldValue("company_document_url", "");
    setCompanyDocFileName("");
  } finally {
    setUploadingCompanyDoc(false);
    if (companyDocInputRef.current) companyDocInputRef.current.value = "";
  }
};

  const savedAddressFromProfile = () => {
    const v = formik.values;
    const line = (v.business_address || "").trim();
    if (line) return line;
    return [v.street_address, v.city, v.province, v.postal_code, v.country].filter(Boolean).join(", ");
  };

const fetchAddress = ({ lat, lng }) => {
  const fallback = () => savedAddressFromProfile() || "";

  if (!window.google?.maps?.Geocoder) {
    console.log("⚠️ Google Maps not loaded");
    const fb = fallback();
    setAddress((prev) => (fb || prev) || "Address not found");
    setDisplayAddress((prev) => (fb || prev) || "Address not found");
    return;
  }

  if (!isOnline()) {
    console.error("❌ No internet connection");
    toast.error(t("locationInternetError") || "No internet connection");
    setAddress("No internet connection");
    setDisplayAddress("No internet connection");
    return;
  }

  console.log("🗺️ Fetching address for:", { lat, lng });
  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ location: { lat, lng } }, (results, status) => {
    console.log("🗺️ Geocoding status:", status);

    if (status === "OK" && results?.length) {
      const best = pickReverseGeocodeResult(results);
      const formattedAddress = best?.formatted_address?.trim();
      if (!formattedAddress) {
        const fb = fallback();
        setAddress(fb || "Address not found");
        setDisplayAddress(fb || "Address not found");
        return;
      }

      const parsed = parseGoogleAddressComponents(best.address_components);
      const {
        country,
        province,
        city,
        community,
        postalCode,
        streetAddress,
        iso2,
      } = parsed;

      setAddress(formattedAddress);
      setDisplayAddress(formattedAddress);

      formik.setFieldValue("country", country);
      formik.setFieldValue("province", province);
      formik.setFieldValue("community", community || "");

      setSelectedCountry(country);
      setSelectedState(province);
      setSelectedCity(city);

      if (!formik.values.city || manualAddress) {
        formik.setFieldValue("city", city);
      }

      formik.setFieldValue("postal_code", postalCode);
      formik.setFieldValue("street_address", streetAddress);
      formik.setFieldValue("region_code", iso2);
      formik.setFieldValue("latitude", lat);
      formik.setFieldValue("longitude", lng);
      formik.setFieldValue("timezone", Intl.DateTimeFormat().resolvedOptions().timeZone || "");
      formik.setFieldValue("countryCode", iso2);
      formik.setFieldValue("region", iso2ToContinent(iso2));
      formik.setFieldValue("continent", iso2ToContinent(iso2));

      if (!manualAddress) {
        formik.setFieldValue("business_address", formattedAddress);
      }
    } else {
      if (!isOnline()) {
        setAddress("No internet connection");
        setDisplayAddress("No internet connection");
      } else {
        const fb = fallback();
        setAddress(fb || "Address not found");
        setDisplayAddress(fb || "Address not found");
      }
    }
  });
};

useEffect(() => {
  const coords = normalizeLatLng(initialLocation?.lat, initialLocation?.lng);
  if (!coords) return;
  setPosition(coords);
  fetchAddress(coords);
  // Only re-sync map/address when profile coords arrive; fetchAddress is intentionally omitted (stable behavior per load).
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [initialLocation]);

  const updatePosition = (coords) => {
    setPosition(coords);
    fetchAddress(coords);
  };

  const handleDragEnd = (e) => {
    const coords = { lat: e.target.getLatLng().lat, lng: e.target.getLatLng().lng };
    updatePosition(coords);
  };

const getCurrentLocation = () => {
  if (!navigator.geolocation) {
    console.error("❌ Geolocation not supported");
    toast.error(t("geolocationNotSupported") || "Geolocation not supported");
    setShowPermissionModal(true);
    return;
  }

  // Check internet connectivity
  if (!isOnline()) {
    console.error("❌ No internet connection");
    toast.error(t("locationInternetError") || "No internet connection. Please check your connection.");
    setShowPermissionModal(true);
    return;
  }

  console.log("📍 Requesting current location...");
  getPositionWithFallback(
    (pos) => {
      const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      console.log("✅ Current location:", coords);
      setPosition(coords);
      fetchAddress(coords);
      setShowPermissionModal(false); // ✅ Hide modal on success
      
      // Pan map to current location
      if (mapRef) {
        mapRef.panTo(coords);
        mapRef.setZoom(15);
      }
    },
    (error) => {
      console.error("❌ Location error:", error);
      
      if (error.code === error.PERMISSION_DENIED) {
        console.log("❌ Permission denied by user");
        setShowPermissionModal(true);
      } else if (error.code === error.TIMEOUT) {
        toast.error(t("locationTimeout") || "Location request timed out");
      } else {
        toast.error(t("unableToFetchLocation") || "Unable to fetch location");
      }
    }
  );
};


useEffect(() => {
  if (!searchQuery.trim() || !window.google) {
    setSuggestions([]);
    return;
  }

  // Check internet before searching
  if (!isOnline()) {
    console.log("⚠️ No internet - skipping search");
    setSuggestions([]);
    return;
  }

  console.log("🔍 Searching for:", searchQuery);

  const service = new window.google.maps.places.AutocompleteService();

  const request = {
    input: searchQuery,
    types: ["geocode", "establishment"],
  };

  service.getPlacePredictions(request, (predictions, status) => {
    console.log("🔍 Predictions status:", status);

    if (status === window.google.maps.places.PlacesServiceStatus.OK && predictions) {
      setSuggestions(predictions);
    } else {
      setSuggestions([]);
    }
  });
}, [searchQuery]);


// Handle search suggestion selection
const handleSearchSelect = (suggestion) => {
  if (!window.google) return;

  // Check internet before searching
  if (!isOnline()) {
    toast.error(t("locationInternetError") || "No internet connection");
    return;
  }

  console.log("📍 Selected suggestion:", suggestion);
  const geocoder = new window.google.maps.Geocoder();

  geocoder.geocode({ placeId: suggestion.place_id }, (results, status) => {
    console.log("📍 Place geocoding status:", status);

    if (status === "OK" && results[0]) {
      const location = results[0].geometry.location;

      const coords = {
        lat: location.lat(),
        lng: location.lng(),
      };

      console.log("✅ Selected location:", coords);

      setPosition(coords);
      fetchAddress(coords);
      setSearchQuery("");
      setSuggestions([]);

      // Pan map to new location
      if (mapRef) {
        mapRef.panTo(coords);
        mapRef.setZoom(15);
      }
    }
  });
};

// Handle map click
const handleMapClick = (e) => {
  const coords = {
    lat: e.latLng.lat(),
    lng: e.latLng.lng(),
  };
  console.log("🖱️ Map clicked at:", coords);
  setPosition(coords);
  fetchAddress(coords);
};

// Handle marker drag
const handleMarkerDragEnd = (e) => {
  const coords = {
    lat: e.latLng.lat(),
    lng: e.latLng.lng(),
  };
  console.log("🔄 Marker dragged to:", coords);
  setPosition(coords);
  fetchAddress(coords);
};

  const handleSearch = async () => {
    if (!searchQuery) return;
    try {
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          searchQuery
        )}&limit=1`
      );
      const data = await res.json();
      if (data.length > 0) {
        const { lat, lon } = data[0];
        updatePosition({ lat: parseFloat(lat), lng: parseFloat(lon) });
      } else {
        toast.error("No results found");
      }
    } catch {
      toast.error("Search failed");
    }
  };

  // Country/State/City dropdown functions
  const loadCountries = async () => {
    try {
      setLoadingCountries(true);
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/states");
      const json = await res.json();
      const data = Array.isArray(json?.data) ? json.data : [];
      setCountriesData(data);
      setCountries(data.map((c) => c.name).sort());
    } catch {
      toast.error("Failed to load countries");
    } finally {
      setLoadingCountries(false);
    }
  };

  const handleCountryChange = (value) => {
    setSelectedCountry(value);
    setSelectedState("");
    setSelectedCity("");
    setCities([]);
    const match = countriesData.find((c) => c.name === value);
    const nextStates = (match?.states || []).map((s) => s.name).sort();
    setStates(nextStates);
    formik.setFieldValue("country", value);

    // Auto-update map when country is selected
    if (value) {
      geocodeSelection(value, "", "");
    }
  };

  const handleStateChange = async (value) => {
    setSelectedState(value);
    setSelectedCity("");
    setCities([]);
    formik.setFieldValue("province", value);

    // Auto-update map when state is selected
    if (value && selectedCountry) {
      await geocodeSelection(selectedCountry, value, "");
    }

    if (!selectedCountry) return;
    try {
      setLoadingCities(true);
      const res = await fetch("https://countriesnow.space/api/v0.1/countries/state/cities", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ country: selectedCountry, state: value }),
      });
      const json = await res.json();
      const list = Array.isArray(json?.data) ? json.data : [];
      setCities(list.sort());
    } catch {
      toast.error("Failed to load cities");
    } finally {
      setLoadingCities(false);
    }
  };

  const geocodeSelection = async (country, state, city) => {
    try {
      const q = [city, state, country].filter(Boolean).join(", ");
      const res = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(q)}&limit=1`,
        { headers: { "User-Agent": "yourapp/1.0 (contact@example.com)" } }
      );
      const data = await res.json();
      if (Array.isArray(data) && data.length > 0) {
        const coords = { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
        setPosition(coords);
        fetchAddress(coords);
      } else {
        toast.error("Location not found for selection");
      }
    } catch {
      toast.error("Error locating selection");
    }
  };

  const handleCityChange = async (value) => {
    console.log("[DEBUG] handleCityChange called with:", value);
    setSelectedCity(value);
    formik.setFieldValue("city", value);
    console.log("[DEBUG] After setFieldValue, formik.values.city:", formik.values.city);
    await geocodeSelection(selectedCountry, selectedState, value);
  };

const handleGeolocate = () => {
  if (!navigator.geolocation) {
    console.error("❌ Geolocation not supported");
    toast.error(t("geolocationNotSupported") || "Geolocation not supported");
    setShowPermissionModal(true);
    return;
  }

  // Check internet connectivity
  if (!isOnline()) {
    console.error("❌ No internet connection");
    toast.error(t("locationInternetError") || "No internet connection. Please check your connection.");
    setShowPermissionModal(true);
    return;
  }

  getPositionWithFallback(
    (pos) => {
      const coords = { lat: pos.coords.latitude, lng: pos.coords.longitude };
      console.log("✅ Current location:", coords);
      setPosition(coords);
      fetchAddress(coords);
      setShowPermissionModal(false); // ✅ Hide modal on success
      
      // Pan map to current location
      if (mapRef) {
        mapRef.panTo(coords);
        mapRef.setZoom(15);
      }
    },
    (error) => {
      console.error("❌ Location error:", error);
      
      if (error.code === error.PERMISSION_DENIED) {
        console.log("❌ Permission denied by user");
        setShowPermissionModal(true);
      } else if (error.code === error.TIMEOUT) {
        toast.error(t("locationTimeout") || "Location request timed out");
      } else {
        toast.error(t("unableToFetchLocation") || "Unable to fetch location");
      }
    }
  );
};

// Reflect browser location allow/block changes live (no refresh needed).
useLocationPermissionSync({
  onGranted: () => {
    if (showPermissionModal) {
      setShowPermissionModal(false);
      getCurrentLocation();
    }
  },
  onDenied: () => setShowPermissionModal(true),
});
useEffect(() => {
  const handleOnline = () => {
    toast.success(t("internetRestored") || "Internet connection restored");
    // Retry fetching address if coordinates exist
    if (position?.lat && position?.lng && position.lat !== defaultCenter.lat) {
      fetchAddress(position);
    }
  };

  const handleOffline = () => {
    toast.error(t("internetConnectionLost") || "Internet connection lost. Please check your network.");
  };

  window.addEventListener("online", handleOnline);
  window.addEventListener("offline", handleOffline);

  return () => {
    window.removeEventListener("online", handleOnline);
    window.removeEventListener("offline", handleOffline);
  };
}, [position]);

  // Load countries on component mount
  useEffect(() => {
    loadCountries();
  }, []);

  // Fetch account executives
  useEffect(() => {
    const fetchExecutives = async () => {
      try {
        setExecutivesLoading(true);
        const res = await fetch(`${BASE_URL}/super-admin/public/account-executives?no_pagination=true`);
        const data = await res.json();
        if (!res.ok || data.error) throw new Error(data.message || "Failed to load");
        const executivesList = data.data?.account_executives || [];
        setExecutives(executivesList);
        // executives loaded
      } catch (err) {
        toast.error(err.message || "Error fetching executives");
      } finally {
        setExecutivesLoading(false);
      }
    };
    fetchExecutives();
  }, []);

  // Ensure when executives arrive, the selected ID stays consistent
  useEffect(() => {
    if (!executives.length) return;
    if (!formik.values.account_executive_id) return;
    const exists = executives.some(exec => exec.id === formik.values.account_executive_id);
    if (!exists) {
      // If current id isn't in list, clear selection
      formik.setFieldValue("account_executive_id", "");
    }
  }, [executives]);

  
  const imgSrc =
    profileImageRaw ||
    previewUrl ||
    dummy;
  //


  const isManualAddressIncomplete =
  manualAddress &&
  (!selectedCountry || !selectedState || !selectedCity);

  // State to control showing profile form
  const [showProfileForm, setShowProfileForm] = useState(false);

  return (
    <>
      <Box sx={{ borderRadius: 2, px: 2, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', minHeight: 55 }}>
      <Box sx={{display:"flex",flexDirection:"row",gap:2,flexWrap:"wrap"}}>
        </Box>
      
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }} onClick={showProfileForm ? () => setShowProfileForm(false) : onBack}>
          <img src={back} style={{ width: 30, height: 30 }} />
          <CustomText sx={{ ...textStyles.h1, fontWeight: 500, fontSize: '14px', color: '#626F86', textAlign: 'center' }}>
            {t("account_setting_screen.breadcrumb")}
          </CustomText>
        </Box>
      </Box>

      {/* Show Cards First, Profile Form Only When Clicked */}
      {!showProfileForm ? (
        /* Quick Access Cards */
        <Box sx={{ mb: 3, mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: 2,
          }}
        >
          {/* Subscription Card */}
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
              onClick={() => navigate('/subscription-plans')}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card1}
                title={t("account_setting_screen.quickAccess.subscription") || "Subscription"}
                description={t("account_setting_screen.quickAccess.subscriptionDesc") || "View and manage your subscription plans"}
              />
            </Box>
          </Box>

          {/* Work Schedule Card */}
          {canAccess("attendance") && (
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
              onClick={() => navigate('/attendance-settings')}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card2}
                title={t("account_setting_screen.quickAccess.workSchedule") || "Work Schedule"}
                description={t("account_setting_screen.quickAccess.workScheduleDesc") || "Configure working hours, schedules, and arrival time windows"}
              />
            </Box>
          </Box>
          )}



   <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
               onClick={() => setOpenChangePassword(true)}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card2}
                title={t("Update Password") || "Update Password"}
                description={t("description") }
              />
            </Box>
          </Box>
          {/* Department Card */}
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
              onClick={() => navigate('/department')}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card3}
                title={t("account_setting_screen.quickAccess.department") || "Department"}
                description={t("account_setting_screen.quickAccess.departmentDesc") || "Manage departments and teams"}
              />
            </Box>
          </Box>

          {/* Profile Settings Card */}
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
              onClick={() => setShowProfileForm(true)}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card1}
                title={t("account_setting_screen.quickAccess.profile") || "Profile Settings"}
                description={t("account_setting_screen.quickAccess.profileDesc") || "Manage your personal details, company information, and account preferences"}
              />
            </Box>
          </Box>

          {/* Delete Account Card */}
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "calc(50% - 8px)",
                md: "calc(33.333% - 12px)",
              },
            }}
          >
            <Box
              onClick={() => setDeleteAccountOpen(true)}
              sx={{ cursor: "pointer" }}
            >
              <SettingCard
                icon={card3}
                title={t("account_setting_screen.quickAccess.deleteAccount") || "Delete Account"}
                description={t("account_setting_screen.quickAccess.deleteAccountDesc") || "Permanently delete your account and all associated data"}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      ) : (
        /* Profile Form - Only shown when Profile Settings card is clicked */
        <Box sx={{ width: '100%',mx: 'auto', backgroundColor: 'white', px: 2, borderRadius: 2, py: 3 }}>
        <Toaster />
        <form onSubmit={formik.handleSubmit}>
        <Box sx={{display:"flex", flexDirection: { xs: "column", sm: "row" }, // column on small screens, row on larger
    gap: 3,
    flexWrap: { xs: "wrap", sm: "nowrap" } ,alignItems:"center",justifyContent:"center"}}>
          <Box sx={{}}>
            {/* --- Profile Image Upload with Cropping --- */}
            <label className="field_label" >{t("profilePicture")}</label>



<Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        mt: 1,
        mb: 2
      }}
    >
      <Box sx={{ position: "relative", width: 120, height: 120 }}>
        {/*************** IF IMAGE EXISTS ***************/}
        {profileImageRaw ? (
          <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
            <img
              crossOrigin="anonymous"
              src={profileImageRaw}
              alt="profile"  onError={(e) => (e.currentTarget.src = dummy)}

              style={{
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                objectFit: "cover"
              }}
            />
            {/* ⭐ TOP-RIGHT SMALL ADD (+) TO REPLACE IMAGE ⭐ */}
            <IconButton
              onClick={() => fileInputRef.current?.click()}
              sx={{
                position: "absolute",
                top: -6,
                right: -6,
                background: "rgba(0,0,0,0.5)",
                borderRadius: "50%",
                padding: "4px",
                "&:hover": {
                  background: "rgba(0,0,0,0.6) !important", // same or darker
                }
              }}
            >
              <AddIcon sx={{ color: "white", fontSize: 20 }} />
            </IconButton>
          </Box>
        ) : (
          /*************** IF NO IMAGE — SHOW DASHED CIRCLE ***************/ 
          <Box
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              border: "1px dashed #999",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              cursor: "pointer",
              position: "relative"
            }}
            onClick={() => !imageUploading && fileInputRef.current?.click()} // Open file input when clicked
          >
            {/* Loader while uploading */}
            {imageUploading && (
              <CircularProgress size={32} sx={{ color: "#666", position: "absolute" }} />
            )}
            {/* Add icon only when not uploading */}
            {!imageUploading && (
              <AddIcon sx={{ fontSize: 28, color: "#666" }} />
            )}
          </Box>
        )}

        {/* Hidden input */}
        <input
          type="file"
          accept="image/*"
          ref={fileInputRef}
          style={{ display: "none" }}
          onChange={handleImageSelect}
        />
      </Box>
    </Box>

            {/* First Name, Middle Name, Last Name in sequence */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("account_setting_screen.fullNameLabel")} <span className="red_asterisk">*</span></label>
                <input className="project_input"
                  name="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: '100%',
                    height: 40,
                    border: formik.touched.firstName && formik.errors.firstName
                      ? "2px solid #d32f2f"
                      : "2px solid #091E4224"
                  }} />
                {formik.touched.firstName && formik.errors.firstName && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.firstName}
                  </span>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                {t("middleName")}
                </label>
                <input className="project_input"
                  name="middleName"
                  value={formik.values.middleName}
                  onChange={formik.handleChange}
                  style={{ width: '100%', height: 40 }} />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label">{t("account_setting_screen.lastNameLabel")} <span className="red_asterisk">*</span></label>
                <input className="project_input"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  style={{
                    width: '100%',
                    height: 40,
                    border: formik.touched.lastName && formik.errors.lastName
                      ? "2px solid #d32f2f"
                      : "2px solid #091E4224"
                  }} />
                {formik.touched.lastName && formik.errors.lastName && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.lastName}
                  </span>
                )}
              </Box>
            </Box>

            {/* DOB and Admin Type */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                 {t("dateOfBirth")} <span className="red_asterisk">*</span>
                </label>
                <input className="project_input"
                  name="dob"
                  type="date"
                  value={formik.values.dob}
                  onChange={(e) => {
                    const val = e.target.value;
                    // Prevent typing more than 4 digits in year
                    const parts = val.split("-");
                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                    }
                    const cleanVal = parts.join("-");
                    formik.setFieldValue("dob", cleanVal);
                    formik.setFieldTouched("dob", true);
                  }}
                  onBlur={formik.handleBlur}
                  style={{
                    width: '100%',
                    height: 40,
                    border: formik.touched.dob && formik.errors.dob
                      ? "2px solid #d32f2f"
                      : "2px solid #091E4224"
                  }} />
                {formik.touched.dob && formik.errors.dob && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.dob}
                  </span>
                )}
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
                <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("administratorType")}
                </label>
                <select className="project_input"
                  name="adminType"
                  value={formik.values.adminType}
                  onChange={formik.handleChange}
                  style={{ width: '100%', height: 40 }}>
                  <option value="">{t("selectType")}</option>
                  <option value="individual">I{t("individual")}</option>
                  <option value="legal_entity">{t("legalEntity")}</option>
                </select>
              </Box>
            </Box>

   


<Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
  <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
    <label
      className="field_label"
      style={{
        letterSpacing: "0.3px",
        textTransform: "capitalize",
        display: "inline-block",
        marginBottom: 7
      }}
    >
      {t("nationalId.label")}
      {formik.values.adminType === 'legal_entity' && <span style={{ color: "red" }}>*</span>}
    </label>
<Box sx={{ position: "relative", mt: 1 }}>
  <input
    ref={docInputRef}
    type="file"
    accept="image/*,.pdf"
    hidden
    onChange={handleAdminDocChange}
  />

  <Box
    onClick={() => !uploadingAdminDoc && handlePickAdminDoc()}
    sx={{
      border: "2px dashed #ccc",
      borderRadius: "8px",
      padding: "20px",
      backgroundColor: "#fafafa",
      cursor: "pointer",
      position: "relative",
      "&:hover": { backgroundColor: "#f0f0f0", borderColor: "#1976d2" }
    }}
  >
    {/* If a document exists — show preview INSIDE the dashed box */}
    {formik.values.adminDocumentUrl ? (
      <>
        {/* Top Row: Icon + File Name + Cross */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 1
          }}
        >
          {/* Icon + File Name */}
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img
              src={getDocumentMeta(formik.values.adminDocumentUrl).icon}
              alt="doc"
              style={{ width: 28, height: 28 }}
            />

            <Box
              sx={{
                maxWidth: "260px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: 14,
                fontWeight: 500,
                color: "#333"
              }}
            >
              {getDocumentMeta(formik.values.adminDocumentUrl).fileName}
            </Box>
          </Box>

          {/* Cross */}
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setAdminDocFileName("");
              formik.setFieldValue("adminDocumentUrl", "");
            }}
            sx={{
              width: 30,
              height: 30,
              backgroundColor: "#fff",
              border: "1px solid #ddd",
              "&:hover": { backgroundColor: "#eee" }
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* View Document button */}
        <Box sx={{ textAlign: "right", mt: 1 }}>
          <button
            onClick={(e) => {
              e.stopPropagation();
              window.open(formik.values.adminDocumentUrl, "_blank");
            }}
            style={{
              backgroundColor: "#1976d2",
              border: "none",
              padding: "6px 12px",
              color: "white",
              borderRadius: 4,
              fontSize: 13,
              cursor: "pointer"
            }}
          >
          {t("viewDocument")}
          </button>
        </Box>
      </>
    ) : (
      /* Default upload UI when no doc exists */
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <Box sx={{ fontSize: "24px", color: "#666" }}>📎</Box>
        <Box sx={{ fontSize: "14px", color: "#666" }}>
          {adminDocFileName || t("settings.dragFileHere")}
        </Box>

        {uploadingAdminDoc && (
          <Box sx={{ fontSize: "12px", color: "#1976d2" }}>{t("uploading")}</Box>
        )}
      </Box>
    )}
  </Box>

  {/* Validation Text */}
  <Box sx={{ fontSize: "12px", color: "#666", mt: 0.5 }}>
            {t("upload.validation")}

  </Box>
</Box>

  </Box>
</Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>

              <Box sx={{ flex: 1, mt: 0.8 }}>
                <label className="field_label" style={{ marginTop: "10px" }}>
                  {t("account_setting_screen.phoneLabel")} <span className="red_asterisk">*</span>
                </label>

                <Box
                  sx={{
                    border: formik.touched.phone && formik.errors.phone
                      ? "2px solid #d32f2f"
                      : "2px solid rgba(9,30,66,0.14)",
                    marginTop: "0px",
                    borderRadius: "6px",
                    backgroundColor: "white",
                    "& .form-control": {
                      border: "none !important",
                      outline: "none !important",
                      boxShadow: "none !important",
                      width: "100%",
                      height: "36px",

                      fontSize: "14px",
                      paddingLeft: "48px",
                      borderRadius: "6px",
                      fontFamily: "Poppins, sans-serif !important",
                      backgroundColor: "transparent",
                    },
                    "& .flag-dropdown": {
                      border: "none !important",
                      borderRight: "1px solid #ccc !important",
                      backgroundColor: "#f9f9f9",
                      borderTopLeftRadius: "6px",
                      borderBottomLeftRadius: "6px",
                    },
                  }}
                >
                  <PhoneInput
                    countryCodeEditable={false}  
                    country={"us"} // default Spain
                    value={formik.values.phone}
                    onChange={(value) => {
                      formik.setFieldValue("phone", value);
                      formik.setFieldTouched("phone", true);
                    }}
                    onBlur={() => formik.setFieldTouched("phone", true)}
                    inputProps={{
                      name: "phone",
                      required: true,
                    }}
                    containerClass="react-tel-input"
                    inputClass="form-control"
                    buttonClass="flag-dropdown"
                  />
                </Box>
                {formik.touched.phone && formik.errors.phone && (
                  <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                    {formik.errors.phone}
                  </span>
                )}
              </Box>
            </Box>


            {/* --- Address Details (unchanged) --- */}
            <Box mt={2.5}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000000", textAlign: "left" }}>
                  {t("account_setting_screen.addressSection")}
                </CustomText>
                <img src={down} width={40} height={30} />
              </Box>
                <Box sx={{ mt: 3, mb: 2 }}>
    <Box sx={{ display: "flex", alignItems: "center",gap:1,}}>
      <input
        type="checkbox"
        id="manualAddress"
        checked={manualAddress}
        onChange={(e) => setManualAddress(e.target.checked)}
        style={{ width: 18, height: 18 }}
      />
      <CustomText customStyle={{ ...textStyles.body4, color: theme.palette.text.primary }}>
{t("settings.manualAddress")}
      </CustomText>
    </Box>
  </Box>

       
<Box sx={{ mt: 2 }}>
  {/* Location Actions */}


{searchBarOpen && (
  <Box sx={{ mb: 2, position: "relative" }}>
    <input
      type="text"
      placeholder={t("settings.searchLocationPlaceholder")}
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          e.preventDefault();
          handleSearch();
        }
      }}
      style={{
        width: "100%",
        padding: "10px 14px",
        fontSize: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        marginBottom: "12px",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        fontFamily: "Poppins, sans-serif",
      }}
    />

    {/* Suggestions dropdown */}
    {suggestions.length > 0 && (
      <Box
        component="ul"
        sx={{
          position: "absolute",
          top: "100%",
          left: 0,
          right: 0,
          maxHeight: "200px",
          overflowY: "auto",
          zIndex: 10000,
          mt: 0.5,
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          backgroundColor: "#fff",
          borderRadius: "8px",
          listStyle: "none",
          padding: 0,
          margin: 0,
        }}
      >
        {suggestions.map((sug) => (
          <Box
            component="li"
            key={sug.place_id}
            onClick={() => handleSearchSelect(sug)}
            sx={{
              padding: "10px 14px",
              cursor: "pointer",
              "&:hover": { backgroundColor: "#f0f0f0" },
              borderBottom: "1px solid #eee",
              "&:last-child": { borderBottom: "none" },
            }}
          >
            <Box sx={{ fontSize: "14px", fontWeight: 500, fontFamily: "Poppins, sans-serif" }}>
              {sug.structured_formatting.main_text}
            </Box>
            <Box sx={{ fontSize: "12px", color: "#666", fontFamily: "Poppins, sans-serif" }}>
              {sug.structured_formatting.secondary_text}
            </Box>
          </Box>
        ))}
      </Box>
    )}
  </Box>
)}

  {/* 🗺️ Map Section (shown by default) */}
  {!manualAddress && (
    <>
      <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      justifyContent: "space-between",
      alignItems: "center",
      my: 2,
    }}
  >
    <CustomText customStyle={{ ...textStyles.body4, color: theme.palette.text.primary }}>
       {t("settings.pickFromLiveLocation")} <span style={{ color: "red" }}>*</span>
    </CustomText>
    <Box sx={{ display: "flex", gap: 1 }}>
      <IconButton
        onClick={() => {
          if (navigator.permissions) {
            navigator.permissions
              .query({ name: "geolocation" })
              .then((res) => {
                if (res.state === "denied") {
                  setShowPermissionModal(true);
                } else {
                  setSearchBarOpen((prev) => !prev);
                }
              })
              .catch(() => setSearchBarOpen((prev) => !prev));
          } else {
            setSearchBarOpen((prev) => !prev);
          }
        }}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          borderRadius: 1,
          width: 40,
          height: 31,
          px: 2,
          "&:hover": { backgroundColor: "#1976d2" },
        }}
      >
        <SearchIcon fontSize="small" />
      </IconButton>
      <IconButton
        onClick={handleGeolocate}
        sx={{
          backgroundColor: "#1976d2",
          color: "#fff",
          borderRadius: 1,
          width: 40,
          height: 31,
          px: 2,
          "&:hover": { backgroundColor: "#1976d2" },
        }}
      >
        <RoomIcon fontSize="small" />
      </IconButton>
      <CustomButton
        label={t("fullMap")}
        size="small"
        sx={{
          height: 31,
          minWidth: "unset",
          px: 2,
          backgroundColor: "#1976d2",
          color: "#fff",
          fontSize: 12,
          "&:hover": { backgroundColor: "#115293" },
        }}
        onClick={() => setShowFullMap(true)}
      />
    </Box>
  </Box>
    <Box sx={{ position: "relative", height: 300, borderRadius: 2, overflow: "hidden" }}>
  <GoogleMap
    mapContainerStyle={mapContainerStyle}
    center={position || defaultCenter}
    zoom={15}
    onClick={handleMapClick}
    onLoad={(map) => {
      console.log("🗺️ Map loaded (preview)");
      setMapRef(map);
    }}
    options={{
      zoomControl: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
    }}
  >
    {position && (
      <>
        <Marker
          position={position}
          draggable={true}
          onDragEnd={handleMarkerDragEnd}
        />
        <Circle
          center={position}
          radius={circularRadius}
          options={{
            fillColor: "#1976d2",
            fillOpacity: 0.2,
            strokeColor: "#1976d2",
            strokeOpacity: 0.8,
            strokeWeight: 2,
          }}
        />
      </>
    )}
  </GoogleMap>
</Box>

            <textarea
       type="text"
        readOnly
        value={address}
        placeholder={t("settings.addressDetectedPlaceholder")}
        style={{
             width: "100%",
    padding: "12px",
    fontSize: "16px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    marginTop: "10px",
    backgroundColor: "#f4f4f4",
    fontFamily: "Poppins, sans-serif",
    resize: "vertical",      // allow manual resize if needed
    overflowY: "auto",       // show scroll when text exceeds height
    lineHeight: "1.4",
        }}
      />
    </>
  )}

  {/* Manual Address toggle */}


{manualAddress && (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mb: 2 }}>
    {/* Country Dropdown */}
    <Box>
      <CustomText customStyle={{ ...textStyles.body5, color: "#6B778C", mb: 0.5, letterSpacing: "0.3px", textTransform: "capitalize", textAlign: "left" }}>
        {t("settings.country")} <span style={{ color: "red" }}>*</span>
      </CustomText>
      <FormControl fullWidth size="small" sx={{ /* your styles */ }}>
            <SearchableDropdown
        value={selectedCountry}
        onChange={(value) => handleCountryChange(value)}  // Update selected country
        options={countries}  // List of countries
        placeholder="Select Country"  // Placeholder text
        disabled={loadingCountries}  // Disable if countries are loading
      />
      </FormControl>
    </Box>

    {/* Province/State Dropdown */}
    <Box>
      <CustomText customStyle={{ ...textStyles.body5, color: "#6B778C", mb: 0.5, letterSpacing: "0.3px", textTransform: "capitalize", textAlign: "left" }}>
        {t("settings.province")} <span style={{ color: "red" }}>*</span>
      </CustomText>
      <FormControl fullWidth size="small" disabled={!selectedCountry} sx={{ /* your styles */ }}>
         <SearchableDropdown
        value={selectedState}
        onChange={(value) => handleStateChange(value)}  // Update selected province
        options={states}  // List of provinces
        placeholder="Select Province"
        disabled={!selectedCountry || loadingStates}  // Disable if no country selected or states are loading
      />
      </FormControl>
    </Box>

    {/* City Dropdown */}
    <Box>
      <CustomText customStyle={{ ...textStyles.body5, color: "#6B778C", mb: 0.5, letterSpacing: "0.3px", textTransform: "capitalize", textAlign: "left" }}>
        {t("settings.city")} <span style={{ color: "red" }}>*</span>
      </CustomText>
      <FormControl fullWidth size="small" disabled={!selectedState} sx={{ /* your styles */ }}>
            <SearchableDropdown
        value={formik.values.city}
        onChange={(value) => handleCityChange(value)}  // Update selected city
        options={cities}  // List of cities
        placeholder="Select City"
        disabled={!selectedState || loadingCities}  // Disable if no state selected or cities are loading
      />
      </FormControl>
    </Box>
  </Box>
)}
               
</Box>


            </Box>
</Box>
            <Box >
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000", textAlign: "left" }}>
                {t("account_setting_screen.companyDetails")}
              </CustomText>

              {/* Company Logo Upload */}
              <Box sx={{ mb: 0, mt: 0 }}>
                <label style={{ color: "#626F86", fontSize: "15px", letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("companyLogo") || "Company Logo"}
                </label>
                <Box sx={{ mt: 0, display: "flex", justifyContent: "center", alignItems: "center", gap: 2 }}>
                  <Box
                    sx={{
                      position: "relative",
                      width: 260,
                      height: 120,
                      border: "2px dashed #091E4224",
                      borderRadius: 2,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: uploadingCompanyLogo ? "not-allowed" : "pointer",
                      backgroundColor: companyLogoUrl ? "transparent" : "#f9f9f9",
                      overflow: "hidden"
                    }}
                    onClick={() => !uploadingCompanyLogo && companyLogoInputRef.current?.click()}
                  >
                    {companyLogoUrl ? (
                      <img
                        crossOrigin="anonymous"
                        src={companyLogoUrl}
                        alt="Company Logo"
                        style={{ 
                          width: "100%", 
                          height: "100%", 
                          objectFit: "contain",
                          borderRadius: "8px"

                        }}
                            onError={(e) => {
                                  
                                    // Fallback to static logo if company logo fails to load
                                    e.currentTarget.src = i18n.language === "es" ? websitelogo : projectlogo;
                                  }}
                      />
                    ) : (
                      <Box sx={{ textAlign: "center", color: "#666" }}>
                        <AddIcon sx={{ fontSize: 48, mb: 1 }} />
                        <div style={{ fontSize: 14 }}>{t("settings.clickToUploadLogo")}</div>
                      </Box>
                    )}
                    
                    <IconButton
                      size="small"
                      sx={{ 
                        fontSize: "14px", 
                        position: "absolute", 
                        top: 8, 
                        right: 8, 
                        backgroundColor: "#fff", 
                        border: "1px solid #ccc", 
                        boxShadow: 1,
                        "&:hover": {
                          backgroundColor: "#f0f0f0"
                        }
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        companyLogoInputRef.current?.click();
                      }}
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                    
                    {uploadingCompanyLogo && (
                      <Box sx={{ 
                        position: "absolute", 
                        inset: 0, 
                        display: "flex", 
                        alignItems: "center", 
                        justifyContent: "center", 
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        borderRadius: "8px"
                      }}>
                        <CircularProgress size={28} />
                      </Box>
                    )}
                  </Box>
                  <input 
                    ref={companyLogoInputRef} 
                    type="file" 
                    accept="image/*" 
                    hidden 
                    onChange={handleCompanyLogoSelect} 
                  />
                </Box>
              </Box>

              <Box display="flex" gap={1.5} mb={2} mt={2}>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label">
                   {t(
    formik.values.adminType === "individual"
      ? "settings.businessName"
      : "settings.companyLegalName"
  )} <span className="red_asterisk">*</span>
                  </label>
                  <input
                    className="project_input"
                    name="legal_name"
                    value={formik.values.legal_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "40px",
                      width: "100%",
                      border: formik.touched.legal_name && formik.errors.legal_name
                        ? "2px solid #d32f2f"
                        : "2px solid #091E4224"
                    }}
                  />
                  {formik.touched.legal_name && formik.errors.legal_name && (
                    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      {formik.errors.legal_name}
                    </span>
                  )}
                </Box>
                {formik.values.adminType !== 'individual' && (
                  <Box sx={{ flex: 1 }}>
                    <label className="field_label">{t("settings.companyBusinessName")}</label>
                    <input
                      className="project_input"
                      name="trade_name"
                      value={formik.values.trade_name}
                      onChange={formik.handleChange}
                      style={{ height: "40px", width: "100%" }}
                    />
                  </Box>
                )}
              </Box>

              <Box display="flex" gap={1.5} mb={2}>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label">{t("account_setting_screen.businessSector")} <span className="red_asterisk">*</span></label>
                  <input
                    className="project_input"
                    name="business_sector"
                    value={formik.values.business_sector}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "40px",
                      width: "100%",
                      border: formik.touched.business_sector && formik.errors.business_sector
                        ? "2px solid #d32f2f"
                        : "2px solid #091E4224"
                    }}
                  />
                  {formik.touched.business_sector && formik.errors.business_sector && (
                    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      {formik.errors.business_sector}
                    </span>
                  )}
                </Box>
              
              </Box>

              {formik.values.adminType !== 'individual' && (
                <Box display="flex" gap={1.5} mb={2}>
                  <Box sx={{ flex: 1 }}>
                    <label className="field_label">{t("account_setting_screen.registrationNumber")}</label>
                    <input
                      className="project_input"
                      name="company_registration_number"
                      value={formik.values.company_registration_number}
                      onChange={formik.handleChange}
                      style={{ height: "40px", width: "100%" }}
                    />
                  </Box>
                </Box>
              )}

              <Box display="flex" gap={1.5} mb={2}>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label">{t("account_setting_screen.businessEmail")}</label>
                  <input
                    className="project_input"
                    name="business_email"
                    value={formik.values.business_email}
                    onChange={formik.handleChange}
                    style={{ height: "40px", width: "100%" }}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label">{t("account_setting_screen.businessPhone")} <span className="red_asterisk">*</span></label>
                  <input
                    className="project_input"
                    name="business_phone_number"
                    value={formik.values.business_phone_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{
                      height: "40px",
                      width: "100%",
                      border: formik.touched.business_phone_number && formik.errors.business_phone_number
                        ? "2px solid #d32f2f"
                        : "2px solid #091E4224"
                    }}
                  />
                  {formik.touched.business_phone_number && formik.errors.business_phone_number && (
                    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      {formik.errors.business_phone_number}
                    </span>
                  )}
                </Box>
              </Box>

              {/* Business Activity */}
              <Box display="flex" gap={1.5} mb={2}>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                  {t("settings.businessActivity")} <span className="red_asterisk">*</span>
                  </label>
                  <textarea
                    className="project_input"
                    name="business_activity"
                    value={formik.values.business_activity}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Describe your business activity..."
                    style={{
                      height: "80px",
                      width: "100%",
                      resize: "vertical",
                      border: formik.touched.business_activity && formik.errors.business_activity
                        ? "2px solid #d32f2f"
                        : "2px solid #091E4224"
                    }}
                  />
                  {formik.touched.business_activity && formik.errors.business_activity && (
                    <span style={{ color: "#d32f2f", fontSize: "12px", marginTop: "4px", display: "block" }}>
                      {formik.errors.business_activity}
                    </span>
                  )}
                </Box>
              </Box>

              {/* Primary and Secondary Colors */}
              <Box display="flex" gap={1.5} mb={2}>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                   {t("settings.primaryColor")}
                  </label>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      name="primary_color"
                      value={formik.values.primary_color}
                      onChange={formik.handleChange}
                      style={{ width: "60px", height: "40px", border: "none", borderRadius: "4px", cursor: "pointer" }}
                    />
                    <input
                      className="project_input"
                      name="primary_color"
                      value={formik.values.primary_color}
                      onChange={formik.handleChange}
                      style={{ height: "40px", width: "calc(100% - 70px)" }}
                    />
                  </Box>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                    {t("settings.secondaryColor")}
                  </label>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <input
                      type="color"
                      name="secondary_color"
                      value={formik.values.secondary_color}
                      onChange={formik.handleChange}
                      style={{ width: "60px", height: "40px", border: "none", borderRadius: "4px", cursor: "pointer" }}
                    />
                    <input
                      className="project_input"
                      name="secondary_color"
                      value={formik.values.secondary_color}
                      onChange={formik.handleChange}
                      style={{ height: "40px", width: "calc(100% - 70px)" }}
                    />
                  </Box>
                </Box>
                
              </Box>
    <Box mt={2}>
{/* 
              <CustomDropdownInput
                label={t("selectAccountExecutive") || "Account Executive"}
                // required
                value={formik.values.account_executive_id}
                onChange={(val) => formik.setFieldValue("account_executive_id", val)}
                options={executives}
                getOptionLabel={(opt) => `${opt.full_name} (${opt.email})`}
                getOptionValue={(opt) => opt.id}
              /> */}
              <CustomDropdownInput
  label={t("selectAccountExecutive")}
  value={formik.values.account_executive_id}
  enableSearch={true}                 // ✅ search UI
  loading={executivesLoading}         // ✅ loader inside dropdown
  disabled={executivesLoading}        // ✅ prevent interaction
  options={executives}
  getOptionLabel={(opt) => `${opt.full_name} (${opt.email})`}
  getOptionValue={(opt) => opt.id}
  onChange={(val) => {
    if (!executivesLoading) {
      formik.setFieldValue("account_executive_id", val);
    }
  }}
/>



            </Box>

      
              

{formik.values.adminType === "legal_entity" && (
  <Box display="flex" gap={1.5} mb={2}>
    <Box sx={{ flex: 1 }}>
      <label
        className="field_label"
        style={{
          letterSpacing: "0.3px",
          textTransform: "capitalize",
          display: "inline-block",
          marginBottom: 7,
        }}
      >
        {t("settings.companyLegalDocument")} <span style={{ color: "red" }}>*</span>
      </label>

      {/* MAIN WRAPPER */}
      <Box sx={{ position: "relative", mt: 1 }}>
        <input
          ref={companyDocInputRef}
          type="file"
          accept="image/*,.pdf"
          hidden
          onChange={handleCompanyDocChange}
        />

        {/* DASHED BOX */}
        <Box
          onClick={() => !uploadingCompanyDoc && handlePickCompanyDoc()}
          sx={{
            border: "2px dashed #ccc",
            borderRadius: "8px",
            padding: "20px",
            backgroundColor: "#fafafa",
            cursor: uploadingCompanyDoc ? "not-allowed" : "pointer",
            position: "relative",
            "&:hover": { backgroundColor: "#f0f0f0", borderColor: "#1976d2" },
          }}
        >

          {/* IF DOCUMENT EXISTS → SHOW PREVIEW */}
          {formik.values.company_document_url ? (
            <>
              {/* FILE ROW: ICON + NAME + CROSS */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mb: 1,
                }}
              >
                {/* Icon + file name */}
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <img
                    src={getDocumentMeta(formik.values.company_document_url).icon}
                    alt="file"
                    style={{ width: 28, height: 28 }}
                  />

                  <Box
                    sx={{
                      maxWidth: "260px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      fontSize: 14,
                      fontWeight: 500,
                      color: "#333",
                    }}
                  >
                    {getDocumentMeta(formik.values.company_document_url).fileName}
                  </Box>
                </Box>

                {/* Cross remove */}
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    setCompanyDocFileName("");
                    formik.setFieldValue("company_document_url", "");
                  }}
                  sx={{
                    width: 30,
                    height: 30,
                    backgroundColor: "#fff",
                    border: "1px solid #ddd",
                    "&:hover": { backgroundColor: "#eee" },
                  }}
                >
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>

              {/* View Document button */}
              <Box sx={{ textAlign: "right", mt: 1 }}>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(formik.values.company_document_url, "_blank");
                  }}
                  style={{
                    backgroundColor: "#1976d2",
                    border: "none",
                    padding: "6px 12px",
                    color: "white",
                    borderRadius: 4,
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                 {t("viewDocument")}
                </button>
              </Box>
            </>
          ) : (
            /* NO DOCUMENT YET → DEFAULT UPLOAD UI */
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 1,
              }}
            >
              <Box sx={{ fontSize: "24px", color: "#666" }}>📎</Box>
              <Box sx={{ fontSize: "14px", color: "#666" }}>
                {companyDocFileName || t("settings.dragFileHere")}
              </Box>

              {uploadingCompanyDoc && (
                <Box sx={{ fontSize: "12px", color: "#1976d2" }}>
                  {t("uploading")}
                </Box>
              )}
            </Box>
          )}
        </Box>

        {/* Validation Text */}
        <Box sx={{ fontSize: "12px", color: "#999", mt: 0.5 }}>
          {t("upload.validation")}
        </Box>
      </Box>
    </Box>
  </Box>
)}



              {/* Business Address (only for legal entity) */}
              {formik.values.adminType === 'legal_entity' && (
                <Box display="flex" gap={1.5} mb={2}>
                  <Box sx={{ flex: 1 }}>
                    <label className="field_label" style={{ letterSpacing: "0.3px", textTransform: "capitalize", display: "inline-block", marginBottom: 7 }}>
                    {t("settings.businessAddress")} <span style={{ color: "red" }}>*</span>
                    </label>
                    <textarea
                      className="project_input"
                      name="business_address"
                      value={formik.values.business_address || ""}
                      onChange={formik.handleChange}
                      placeholder="Enter your business address..."
                      style={{ height: "80px", width: "100%", resize: "vertical" }}
                    />
                  </Box>
                </Box>
              )}
            </Box>

            
</Box>

            {/* --- Support / Account Executive Section --- */}
            <Box mt={3}>
              <CustomText sx={{ ...textStyles.h1, fontSize: 18, fontWeight: 600, color: "#000", textAlign: "left", mb: 2 }}>
                {t("account_setting_screen.supportSection") || "Support"}
              </CustomText>
              
              {accountExecutiveInfo ? (
                <Box 
                  sx={{ 
                    mt: 2, 
                    p: 2.5, 
                    border: "1px solid #E0E0E0", 
                    borderRadius: 2,
                    backgroundColor: "#FAFAFA"
                  }}
                >
                  <CustomText sx={{ fontSize: 16, fontWeight: 600, color: "#172B4D", mb: 1.5 }}>
                    {t("account_setting_screen.accountExecutive") || "Account Executive"}
                  </CustomText>
                  
                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    {accountExecutiveInfo.full_name && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <CustomText sx={{ fontSize: 14, fontWeight: 600, color: "#5E5C5C", minWidth: 80 }}>
                          {t("account_setting_screen.name") || "Name"}:
                        </CustomText>
                        <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
                          {accountExecutiveInfo.full_name}
                        </CustomText>
                      </Box>
                    )}
                    
                    {accountExecutiveInfo.email && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <CustomText sx={{ fontSize: 14, fontWeight: 600, color: "#5E5C5C", minWidth: 80 }}>
                          {t("account_setting_screen.email") || "Email"}:
                        </CustomText>
                        <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
                          {accountExecutiveInfo.email}
                        </CustomText>
                      </Box>
                    )}
                    
                    {accountExecutiveInfo.phone && (
                      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        <CustomText sx={{ fontSize: 14, fontWeight: 600, color: "#5E5C5C", minWidth: 80 }}>
                          {t("account_setting_screen.phone") || "Phone"}:
                        </CustomText>
                        <CustomText sx={{ fontSize: 14, color: "#172B4D" }}>
                          {accountExecutiveInfo.phone}
                        </CustomText>
                      </Box>
                    )}
                  </Box>
                </Box>
              ) : (
                <Box 
                  sx={{ 
                    mt: 2, 
                    p: 3, 
                    border: "1px dashed #D0D5DD", 
                    borderRadius: 2,
                    backgroundColor: "#F9FAFB",
                    textAlign: "center"
                  }}
                >
                  <CustomText sx={{ fontSize: 14, color: "#8B8B8B" }}>
                    {t("account_setting_screen.noAccountExecutive") || "No Account Executive assigned"}
                  </CustomText>
                </Box>
              )}
            </Box>

            <Box mt={3}>
              <CustomButton
                disabled={ isManualAddressIncomplete}

                type="submit"
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {/* Loader to the LEFT of "Save" */}
                    {savingProfile && <CircularProgress size={16} sx={{ color: "#fff" }} />}
                    <img src={save} alt="save" width={16} height={16} />
               {t("update")}
                  </Box>
                }
                size="medium"
              />
            </Box>
          {/* </Box> */}
        </form>
        </Box>
      )}

{/* Full-screen Map */}
{showFullMap && (
  <Box
    sx={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "#fff",
      zIndex: 1300,
    }}
  >
    <IconButton
      onClick={() => {
        console.log("🗺️ Closing full map");
        setShowFullMap(false);
      }}
      sx={{ position: "absolute", top: 16, right: 16, zIndex: 1400 }}
    >
      <img src={crossmap} alt="close" style={{ width: 50, height: 50 }} />
    </IconButton>
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "100%" }}
      center={position || defaultCenter}
      zoom={15}
      onClick={handleMapClick}
      onLoad={(map) => {
        console.log("🗺️ Full map loaded");
      }}
      options={{
        zoomControl: true,
        streetViewControl: false,
        mapTypeControl: false,
        fullscreenControl: false,
      }}
    >
      {position && (
        <>
          <Marker
            position={position}
            draggable={true}
            onDragEnd={handleMarkerDragEnd}
          />
          <Circle
            center={position}
            radius={circularRadius}
            options={{
              fillColor: "#1976d2",
              fillOpacity: 0.2,
              strokeColor: "#1976d2",
              strokeOpacity: 0.8,
              strokeWeight: 2,
            }}
          />
        </>
      )}
    </GoogleMap>
  </Box>
)}
      {/* Permission Modal */}
   <LocationPermissionModal
  open={showPermissionModal}
  onAllow={() => {
    console.log("✅ Location permission allowed");
    setShowPermissionModal(false);
    getCurrentLocation(); // ✅ Retry after user allows
  }}
  onCancel={() => {
    console.log("❌ Location permission cancelled");
    setShowPermissionModal(false);
  }}
/>

      {/* Image Cropper Modal */}
      {cropModalOpen && (
        <ImageCropper
          onCropComplete={handleCropComplete}
          selectedImage={selectedImage}
          onClose={() => {
            setCropModalOpen(false);
            setSelectedImage(null);
          }}
        />
      )}

      {/* Company Logo Cropper Modal */}
      {companyLogoCropModalOpen && (
        <ImageCropper
          onCropComplete={handleCompanyLogoCropComplete}
          selectedImage={selectedCompanyLogoImage}
          onClose={() => {
            setCompanyLogoCropModalOpen(false);
            setSelectedCompanyLogoImage(null);
          }}
        />
      )}
      <ChangePassword
  open={openChangePassword}
  onClose={() => setOpenChangePassword(false)}
/>

      <DeleteSettingsModal
        open={deleteAccountOpen}
        loading={deleteAccountLoading}
        onClose={() => setDeleteAccountOpen(false)}
        onConfirm={handleDeleteAccount}
      />
    </>
  );
};

export default AccountSetting;











































































